export function waitForElementDefined(tagName: string): Promise<void> {
  return new Promise<void>((resolve) => {
    if (customElements.get(tagName)) {
      resolve();
    } else {
      customElements.whenDefined(tagName).then(() => {
        resolve();
      });
    }
  });
}

export function observeElementInsertion(
  selector: string,
): Promise<HTMLElement> {
  const elementPromise = new Promise((resolve) => {
    const observer = new MutationObserver(() => {
      const el = document.querySelector(selector) as HTMLElement;
      if (el) {
        observer.disconnect();
        resolve(el);
        return;
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });

  return Promise.race([wait(5000, `can't find ${selector}`), elementPromise]);
}

function wait(ms: number, message: string): Promise<any> {
  return new Promise((_, reject) => {
    setTimeout(() => {
      reject(new Error(message));
    }, ms);
  });
}
